import React, { Component } from 'react';
import {
  Select,
  Typography,
  Button,
  Modal,
  List,
  message,
  Popconfirm,
} from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getIssues,
  channelAdminConfig,
  getServiceDeskProject,
  updateSkill,
} from '../skills_action';
import queryString from 'query-string';

const { Option } = Select;
const { Text } = Typography;

class RequestTypeRestriction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      selectedProject: null,
      selectedRequestTypes: [],
      requestTypesLoading: false,
      saveLoading: false,
    };
  }

  componentDidMount() {
    if (
      this.props.match.params.sub_skill === 'jira_service_desk' &&
      this.props.globalLevel
    )
      this.props.getServiceDeskProject(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        { saveInBoth: true }
      );
  }

  onChangeProject = async (value, data) => {
    const { channelCommonData, currentSkill, channelDefault } = this.props;
    this.setState({ selectedProject: data.project, selectedRequestTypes: [] });
    this.props
      .getIssues(this.props.match.params.wId, data.key, true)
      .then((res) => {
        // if (res.data.success && (this.props.globalLevel ? currentSkill.globalRequestTypeRestriction : channelCommonData && channelCommonData.requestTypeRestriction)) {
        //     const projectFound = (this.props.globalLevel ? currentSkill.globalRequestTypeRestriction : channelCommonData.requestTypeRestriction).find(
        //       (restriction) => restriction.project.projectId === data.project.projectId
        //     );
        //     if (projectFound) this.setState({ selectedRequestTypes: projectFound.requestTypes });
        //   }

        if (res.data.success) {
          /* to handle already configured projects */
          if (
            (this.props.globalLevel
              ? currentSkill.globalRequestTypeRestriction
              : channelCommonData &&
                channelCommonData.requestTypeRestriction &&
                channelCommonData.requestTypeRestriction.length > 0) &&
            (this.props.globalLevel
              ? currentSkill.globalRequestTypeRestriction
              : channelCommonData.requestTypeRestriction
            ).find(
              (restriction) =>
                restriction.project.projectId === data.project.projectId
            )
          ) {
            const projectFound = (
              this.props.globalLevel
                ? currentSkill.globalRequestTypeRestriction
                : channelCommonData.requestTypeRestriction
            ).find(
              (restriction) =>
                restriction.project.projectId === data.project.projectId
            );
            if (projectFound)
              this.setState({
                selectedRequestTypes: projectFound.requestTypes,
              });
          } else {
            /* to add the request type from channel default and global request default */

            let selectedRequestTypes = [];
            if (
              this.props.globalLevel
                ? currentSkill &&
                  currentSkill.globalDefaults &&
                  currentSkill.globalDefaults.ticketDefaults &&
                  currentSkill.globalDefaults.ticketDefaults
                    .defaultRequestType &&
                  currentSkill.globalDefaults.ticketDefaults.defaultProject
                    .projectId === data.project.projectId
                : channelDefault &&
                  channelDefault.link_info &&
                  channelDefault.link_info.project &&
                  channelDefault.link_info.project_id ===
                    data.project.projectId &&
                  channelDefault.link_info.requestType &&
                  channelDefault.link_info.requestType.id
            ) {
              if (this.props.channelLevel)
                channelDefault.link_info.requestType.text =
                  channelDefault.link_info.requestType.name;

              selectedRequestTypes = [
                ...this.state.selectedRequestTypes,
                this.props.globalLevel
                  ? currentSkill.globalDefaults.ticketDefaults
                      .defaultRequestType
                  : channelDefault.link_info.requestType,
              ];
            }

            if (
              this.props.channelLevel &&
              currentSkill.globalRequestTypeRestriction &&
              currentSkill.globalRequestTypeRestriction.find(
                (restriction) =>
                  restriction.project.projectId === data.project.projectId
              )
            ) {
              const projectFound =
                currentSkill.globalRequestTypeRestriction.find(
                  (restriction) =>
                    restriction.project.projectId === data.project.projectId
                );
              projectFound.requestTypes.forEach((requestType) => {
                if (
                  !selectedRequestTypes.find((r) => r.id === requestType.id)
                ) {
                  selectedRequestTypes.push(requestType);
                }
              });
            }

            this.setState({
              selectedRequestTypes,
            });
          }
        }
      });
  };

  onRequestTypeChange = async (value, data) => {
    if (data.length <= 90)
      this.setState({ selectedRequestTypes: data.map((d) => d.requestType) });
  };

  handleSave = () => {
    const { selectedProject, selectedRequestTypes } = this.state;
    const { channelCommonData, currentSkill } = this.props;
    const { channel_id } = queryString.parse(window.location.search);
    this.setState({ saveLoading: true });

    if (this.props.globalLevel) {
      let data = {
        globalRequestTypeRestriction: currentSkill.globalRequestTypeRestriction
          ? [...currentSkill.globalRequestTypeRestriction]
          : [],
      };
      const restrictionFound = data.globalRequestTypeRestriction.find(
        (restriction) =>
          restriction.project.projectId === selectedProject.projectId
      );
      if (restrictionFound) {
        data.globalRequestTypeRestriction =
          data.globalRequestTypeRestriction.map((restriction) =>
            restriction.project.projectId === selectedProject.projectId
              ? {
                  project: selectedProject,
                  requestTypes: selectedRequestTypes,
                }
              : restriction
          );
      } else {
        data.globalRequestTypeRestriction.push({
          project: selectedProject,
          requestTypes: selectedRequestTypes,
        });
      }

      this.props
        .updateSkill(
          this.props.match.params.skill_id,
          this.props.match.params.wId,
          data
        )
        .then((res) => {
          if (res.data.success)
            this.setState({
              saveLoading: false,
              modalVisible: false,
              selectedProject: null,
              selectedRequestTypes: [],
            });
        });
    } else if (this.props.channelLevel) {
      if (channelCommonData) {
        let data = {
          requestTypeRestriction: channelCommonData.requestTypeRestriction
            ? [...channelCommonData.requestTypeRestriction]
            : [],
        };
        const restrictionFound = data.requestTypeRestriction.find(
          (restriction) =>
            restriction.project.projectId === selectedProject.projectId
        );
        if (restrictionFound) {
          data.requestTypeRestriction = data.requestTypeRestriction.map(
            (restriction) =>
              restriction.project.projectId === selectedProject.projectId
                ? {
                    project: selectedProject,
                    requestTypes: selectedRequestTypes,
                  }
                : restriction
          );
        } else {
          data.requestTypeRestriction.push({
            project: selectedProject,
            requestTypes: selectedRequestTypes,
          });
        }
        this.props
          .channelAdminConfig(
            this.props.match.params.wId,
            this.props.match.params.skill_id,
            channelCommonData.channel_id,
            data,
            false
          )
          .then((res) => {
            if (res.data.success)
              this.setState({
                saveLoading: false,
                modalVisible: false,
                selectedProject: null,
                selectedRequestTypes: [],
              });
          });
      } else {
        message.error('Something went wrong');
        this.props.history.push(
          `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${this.props.match.params.sub_skill}?view=channel_preferences`
        );
      }
    }
  };

  handleUpdate = ({ projectId }) => {
    const { channelCommonData, jsd_projects, currentSkill } = this.props;
    const project = jsd_projects.find((p) => p.projectId === projectId);

    if (project) {
      this.setState({
        selectedProject: project,
        selectedRequestTypes: [],
        requestTypesLoading: true,
        modalVisible: true,
      });
      this.props
        .getIssues(this.props.match.params.wId, project.id, true)
        .then((res) => {
          if (
            res.data.success &&
            (this.props.globalLevel
              ? currentSkill.globalRequestTypeRestriction
              : channelCommonData && channelCommonData.requestTypeRestriction)
          ) {
            const projectFound = (
              this.props.globalLevel
                ? currentSkill.globalRequestTypeRestriction
                : channelCommonData.requestTypeRestriction
            ).find(
              (restriction) =>
                restriction.project.projectId === project.projectId
            );
            this.setState({
              selectedRequestTypes: projectFound.requestTypes,
              requestTypesLoading: false,
            });
          }

          if (
            res.data.success &&
            channelCommonData &&
            channelCommonData.requestTypeRestriction
          ) {
            const projectFound = channelCommonData.requestTypeRestriction.find(
              (restriction) =>
                restriction.project.projectId === project.projectId
            );
            this.setState({
              selectedRequestTypes: projectFound.requestTypes,
              requestTypesLoading: false,
            });
          }
        });
    }
  };

  handleDelete = ({ projectId }) => {
    const { channelCommonData, globalLevel, currentSkill } = this.props;
    let temp = [];

    const restrictions = globalLevel
      ? currentSkill.globalRequestTypeRestriction
      : channelCommonData.requestTypeRestriction;

    restrictions.forEach((restriction) => {
      if (restriction.project.projectId !== projectId) temp.push(restriction);
    });

    if (globalLevel)
      this.props.updateSkill(
        this.props.match.params.skill_id,
        this.props.match.params.wId,
        { globalRequestTypeRestriction: temp }
      );
    else
      this.props.channelAdminConfig(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        channelCommonData.channel_id,
        { requestTypeRestriction: temp },
        false
      );
  };

  render() {
    const { selectedProject, selectedRequestTypes } = this.state;
    const {
      requests,
      channelCommonData,
      currentSkill,
      channelDefault,
      isWorkspaceAdmin,
      isChannelAdmin,
      globalLevel,
    } = this.props;
    let data = [];

    if (globalLevel) {
      data =
        currentSkill && currentSkill.globalRequestTypeRestriction
          ? currentSkill.globalRequestTypeRestriction.map((restriction) => {
              let description = '';
              restriction.requestTypes.forEach((request, i) => {
                description += request.text;
                if (i !== restriction.requestTypes.length - 1)
                  description += ', ';
              });
              return {
                title: restriction.project.projectName,
                description,
                projectId: restriction.project.projectId,
              };
            })
          : [];
    } else if (this.props.channelLevel) {
      data =
        channelCommonData && channelCommonData.requestTypeRestriction
          ? channelCommonData.requestTypeRestriction.map((restriction) => {
              let description = '';
              restriction.requestTypes.forEach((request, i) => {
                description += request.text;
                if (i !== restriction.requestTypes.length - 1)
                  description += ', ';
              });
              return {
                title: restriction.project.projectName,
                description,
                projectId: restriction.project.projectId,
              };
            })
          : [];
    }

    const list = (
      <List
        // itemLayout="hori"
        dataSource={data}
        renderItem={(item) => (
          <List.Item
            actions={
              (
                globalLevel
                  ? isWorkspaceAdmin
                  : isWorkspaceAdmin || isChannelAdmin
              )
                ? [
                    <Button
                      type='link'
                      onClick={() =>
                        this.handleUpdate({ projectId: item.projectId })
                      }
                    >
                      Update
                    </Button>,
                    <Popconfirm
                      title={
                        'Are you sure you want to remove this request type restriction?'
                      }
                      onConfirm={() =>
                        this.handleDelete({ projectId: item.projectId })
                      }
                      okText='Delete'
                      cancelText='No'
                    >
                      <Button
                        type='link' /* onClick={() => this.handleDelete({ projectId: item.projectId })} */
                      >
                        Delete
                      </Button>
                    </Popconfirm>,
                  ]
                : []
            }
          >
            <List.Item.Meta title={item.title} description={item.description} />
          </List.Item>
        )}
      />
    );

    return (
      <>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 8,
          }}
        >
          {/* <Card
          title={
            <span>
              <span style={{ marginRight: 4 }}>Request Type Restrictions</span>
            </span>
          }
          extra={
            isWorkspaceAdmin ? (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ modalVisible: true });
                }}
              >
                Add
              </Button>
            ) : (
              ""
            )
          }
        > */}
          <div style={{ marginRight: 16 }}>
            <Text>
              <strong>Request type restrictions: </strong>
            </Text>
            <Text type='secondary'>
              Allow only selected request types while creating Requests in Slack
            </Text>
          </div>
          <div>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                this.setState({ modalVisible: true });
              }}
            >
              Add
            </Button>
          </div>
        </div>
        {data.length > 0 && <div>{list}</div>}
        {/* </Card> */}
        <Modal
          visible={this.state.modalVisible}
          title={'Request Type Restriction'}
          closable={false}
          maskClosable={false}
          footer={[
            <Button
              onClick={() =>
                this.setState({
                  modalVisible: false,
                  selectedProject: null,
                  selectedRequestTypes: [],
                })
              }
            >
              Cancel
            </Button>,
            <Button
              key='submit'
              type='primary'
              onClick={() => this.handleSave()}
              loading={this.state.saveLoading}
              disabled={selectedRequestTypes.length <= 0}
            >
              Save
            </Button>,
          ]}
        >
          <Text type='secondary' strong>
            Select Project
          </Text>
          <Select
            style={{ width: '100%' }}
            onChange={this.onChangeProject}
            value={
              selectedProject && selectedProject.projectId
                ? selectedProject.projectId
                : null
            }
            showSearch
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {this.props.jsd_projects &&
              this.props.jsd_projects.map((project) => {
                return (
                  <Option
                    key={project.id}
                    value={project.projectId}
                    project={project} /* disabled={disabled} */
                  >
                    {project.projectName + ` (${project.projectKey})`}
                  </Option>
                );
              })}
          </Select>
          <br />
          <br />
          <Text type='secondary' strong>
            Select Request Types (Max:90)
          </Text>
          <Select
            loading={this.state.requestTypesLoading}
            style={{ width: '100%' }}
            value={selectedRequestTypes.map((request) => request.id)}
            onChange={this.onRequestTypeChange}
            mode='multiple' /* disabled={!selectedProject} */
            showSearch
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {requests.map((requestType) => {
              let disableOption = false;
              /* HANDLING REQUEST TYPE FROM DEFAULT */
              if (
                this.props.globalLevel
                  ? currentSkill &&
                    currentSkill.globalDefaults &&
                    currentSkill.globalDefaults.ticketDefaults &&
                    selectedProject &&
                    currentSkill.globalDefaults.ticketDefaults.defaultProject
                      .projectId === selectedProject.projectId &&
                    currentSkill.globalDefaults.ticketDefaults
                      .defaultRequestType &&
                    currentSkill.globalDefaults.ticketDefaults
                      .defaultRequestType.id === requestType.id
                  : channelDefault &&
                    channelDefault.link_info &&
                    channelDefault.link_info.project &&
                    selectedProject &&
                    channelDefault.link_info.project_id ===
                      selectedProject.projectId &&
                    channelDefault.link_info.requestType &&
                    channelDefault.link_info.requestType.id === requestType.id
              )
                disableOption = true;

              /* HANDLING REQUEST TYPE FROM GLOBAL REQUEST TYPE RESTRICTION */
              if (
                this.props.channelLevel &&
                currentSkill.globalRequestTypeRestriction &&
                selectedProject &&
                currentSkill.globalRequestTypeRestriction.find(
                  (restriction) =>
                    restriction.project.projectId === selectedProject.projectId
                )
              ) {
                const projectFound =
                  currentSkill.globalRequestTypeRestriction.find(
                    (restriction) =>
                      restriction.project.projectId ===
                      selectedProject.projectId
                  );
                if (
                  projectFound.requestTypes.find((r) => r.id === requestType.id)
                )
                  disableOption = true;
              }
              return (
                <Option
                  key={requestType.id}
                  value={requestType.id}
                  requestType={requestType}
                  disabled={disableOption}
                >
                  {requestType.text}
                </Option>
              );
            })}
          </Select>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isWorkspaceAdmin: state.common_reducer.isAdmin,
    requests: state.skills.issues,
    currentSkill: state.skills.currentSkill,
    channelDefault: state.skills.channelDefault,
    jsd_projects: state.skills.jsd_projects,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getIssues,
    channelAdminConfig,
    getServiceDeskProject,
    updateSkill,
  })(RequestTypeRestriction)
);
